import {
  ComponentProps,
  createContext,
  FC,
  ReactElement,
  useContext,
  useReducer
} from 'react';
import {AppModel} from '@shared/context/mappers/AppTypesMapper';
import {initialAppState, appReducer} from '@shared/context/reducers/AppReducer';
import {
  setAppData,
  setApplicationName,
  setMsalConfigData,
  setHospitalId
} from '@shared/context/actions/AppActions';

interface AppContextInterface {
  readonly appState: AppModel;
  readonly updateAppData: () => void;
  readonly setAppName: (applicationName: string) => void;
  readonly setMsalAuthConfig: (authConfig: any) => void;
  readonly setHospitalData: (hospitalId: string) => void;
}

const AppContext = createContext<AppContextInterface>(
  {} as AppContextInterface
);

export const useAppContext = (): AppContextInterface => useContext(AppContext);

export const AppContextProvider = ({
  children
}: ComponentProps<FC<any>> & {children: ReactElement}): JSX.Element => {
  const [appState, dispatch] = useReducer(appReducer, initialAppState);

  const updateAppData = (): void => {
    setAppData(dispatch, {});
  };

  const setAppName = (applicationName: string): void => {
    setApplicationName(dispatch, {applicationName});
  };
  const setHospitalData = (hospitalId: string): void => {
    setHospitalId(dispatch, {hospitalId});
  };

  const setMsalAuthConfig = (authConfig: any): void => {
    setMsalConfigData(dispatch, {authConfig});
  };

  return (
    <AppContext.Provider
      value={{
        appState,
        updateAppData,
        setAppName,
        setMsalAuthConfig,
        setHospitalData
      }}>
      {children}
    </AppContext.Provider>
  );
};
